import React from 'react';
import { Header, Grid, Breadcrumb } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Filter extends React.Component {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.node,
    ]).isRequired,
    isError: PropTypes.bool,
    breadcrumbs: PropTypes.array,
    columnWidths: PropTypes.object,
  };

  static defaultProps = {
    columnWidths: {
      title: 5,
    },
  };

  render() {
    const {
      newRow,
      title,
      children,
      isError,
      breadcrumbs = [],
      columnWidths,
    } = this.props;

    return (
      <section className="filter-header">
        <Grid className="student-list-header-component" padded columns={16}>
          <Grid.Row stretched>
            <Grid.Column width={columnWidths.title}>
              <Header as="h3" className={classNames({ error: isError })}>
                {title}
              </Header>
              {!!breadcrumbs.length && (
                <Breadcrumb size="big">
                  {breadcrumbs.map((item, index) => {
                    const { link, title } = item;
                    const lastItem = index + 1 === breadcrumbs.length;
                    let sectionProps = {};

                    if (link) sectionProps = { href: link };

                    return (
                      <React.Fragment key={index}>
                        <Breadcrumb.Section active={lastItem} {...sectionProps}>
                          {title}
                        </Breadcrumb.Section>
                        {!lastItem && <Breadcrumb.Divider icon="angle right" />}
                      </React.Fragment>
                    );
                  })}
                </Breadcrumb>
              )}
            </Grid.Column>
            {!newRow && (
              <Grid.Column width={16 - columnWidths.title}>
                {children}
              </Grid.Column>
            )}
          </Grid.Row>
          {newRow && (
            <Grid.Row>
              <Grid.Column width={16}>{children}</Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </section>
    );
  }
}

export { Filter };



// WEBPACK FOOTER //
// ./src/containers/app/Filter.js